<template>
	<div>
		<div class="flex w-full justify-center px-4 min-h-40 h-auto">
			<div class="relative overflow-hidden rounded-lg cursor-default w-full max-w-8xl">
				<img src="/images/ob-widget-full0129.jpg" alt="Image" class="w-full h-full object-cover duration-300 rounded-lg" />
				<div class="absolute inset-0 flex items-center justify-center bg-gradient-to-t from-ihh-gradient to-transparent">
					<div class="before-hover w-full">
						<div class="absolute inset-0 flex flex-col items-center justify-center text-white md:gap-y-2">
							<div class="text-2xl sm:text-ihh-h2 tracking-wide font-semibold text-center">Are you a Midwife?</div>
							<div class="text-xs md:text-base">Setup your birth kit with us</div>
							<div class="mt-4 border-2 border-ihh-secondary-white rounded-lg cursor-pointer group overflow-hidden">
								<router-link
									to="new-birth-kit-setup/"
									class="block text-xs sm:text-sm group-hover:bg-ihh-secondary-white px-4 sm:px-8 py-2 sm:py-3 transition ease-in-out"
									>Get started</router-link
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
}
</script>
